// extracted by mini-css-extract-plugin
export default {"content":"e2naZMBxvghfSGk1gc0V"};